import createComputed from 'modules/core/hooks/createComputed'
import usersWithRegularAccess from 'modules/core/lib/usersWithRegularAccess'
import { type Users } from 'modules/core/store/collections/users'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { peopleManagedByEmployee } from 'modules/employees/store/collections/employeesContractVersions'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { peopleLedByEmployee } from 'modules/teams/store/peopleLedByEmployee'

// FIXME: Refactor this aberration. We should not be managing all this in frontend.
export const useManageableUserIds = createComputed(
  (users: Users, contractVersions: ContractVersions) => {
    if (users.current.policy.can('competencies.assessmentsManageEverybody')) {
      return new Set(usersWithRegularAccess(users.active).map((u) => u.attributes.id))
    }

    const usersList: Set<number> = new Set()

    const currentEmployee = users.current.employee

    if (!currentEmployee) return new Set([])

    if (users.current.policy.can('competencies.assessmentsManageOwned')) {
      usersList.add(users.current.id)
    }

    if (users.current.policy.can('competencies.assessmentsManageTeam')) {
      const ledPeople = peopleLedByEmployee(
        teams,
        memberships,
        currentEmployee.id,
        contractVersions
      )

      for (const ledPerson of ledPeople) {
        usersList.add(ledPerson.id)
      }
    }

    if (users.current?.policy.can('competencies.assessmentsManageReportees')) {
      const managedPeople = peopleManagedByEmployee(currentEmployee.id, contractVersions)

      for (const managedPerson of managedPeople) {
        usersList.add(managedPerson.id)
      }
    }

    return new Set(usersList)
  }
)
